module.exports = __webpack_public_path__ + "assets/img/btn-detail-d8a94587.png";